import React, { Component } from 'react'
import { List } from 'antd'
import CardDetails from './CardDetails'

class PhonebookGrid extends Component {
  render() {
    const { currentList, auth, handleOnRowClick } = this.props
    return (
      <List
        style={{ margin: 20 }}
        grid={{ gutter: 10, xs: 1, sm: 1, md: 2, lg: 2, xl: 3, xxl: 4 }}
        dataSource={currentList}
        renderItem={(member) => (
          <List.Item>
            <CardDetails member={member} auth={auth} handleOnRowClick={handleOnRowClick.bind(this, member)} />
          </List.Item>
        )}
      />
    )
  }
}

export default PhonebookGrid
